import React, { Component } from 'react';
import '../styles/Users.css';
import { getUsers, websiteLimit, deleteUser, deleteUserProfile } from '../services/usersService';
import { getMyChannels, updateMyChannels } from '../services/channelsService';
import qs from "qs";
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Avatar,
  Select,
  MenuItem,
  Link as MuiLink,
  Tooltip,
  Collapse,
  IconButton,
  Chip,
  Menu,
  Checkbox,
  FormControlLabel,
  Divider,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  LinearProgress
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import LanguageIcon from '@mui/icons-material/Language';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import TwitterIcon from '@mui/icons-material/Twitter';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import LinkIcon from '@mui/icons-material/Link';
import FilterListIcon from '@mui/icons-material/FilterList';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      q: '',
      // Advanced filters / options
      website_id: '',
      age_min: '',
      age_max: '',
      profile_email: '',
      uid: '',
      sort_field: 'created_at',
      sort_type: 'desc',
      page_size: 10,
      sizeFlag: false,
      countFlag: false,
      showAdvanced: false,
      // Special result modes
      resultsSize: null,   // number when size=true
      resultsCount: null,  // number when count=true

      expanded: {},          // { userId: boolean }
      menuAnchorEl: null,    // menu contextuel
      menuItem: null,
      // Channels dialog (current admin user) per website
      channelsDialogOpen: false,
      channelsWebsiteId: '',
      channelsLoading: false,
      channelsData: null,
      channelsEdits: {}
    };
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.fetchPage = this.fetchPage.bind(this);
    this.updateLimitCreateWebsite = this.updateLimitCreateWebsite.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.handleDeleteProfile = this.handleDeleteProfile.bind(this);
    this.openChannelsDialog = this.openChannelsDialog.bind(this);
    this.closeChannelsDialog = this.closeChannelsDialog.bind(this);
    this.toggleChannel = this.toggleChannel.bind(this);
    this.saveChannels = this.saveChannels.bind(this);
  }

  async openChannelsDialog(websiteId) {
    if (!websiteId) return;
    this.setState({ channelsDialogOpen: true, channelsWebsiteId: websiteId, channelsLoading: true, channelsData: null, channelsEdits: {} });
    try {
      const data = await getMyChannels(websiteId);
      if (!this._isMounted) return;
      this.setState({ channelsData: data || {}, channelsEdits: data || {}, channelsLoading: false });
    } catch (e) {
      alert(`Erreur lors du chargement des canaux: ${e?.message || e}`);
      this.setState({ channelsLoading: false });
    }
  }

  closeChannelsDialog() {
    this.setState({ channelsDialogOpen: false, channelsWebsiteId: '', channelsData: null, channelsEdits: {} });
  }

  toggleChannel(key, field) {
    this.setState((prev) => ({
      channelsEdits: {
        ...prev.channelsEdits,
        [key]: { email: Boolean(prev.channelsEdits?.[key]?.email), push: Boolean(prev.channelsEdits?.[key]?.push), ...prev.channelsEdits?.[key], [field]: !Boolean(prev.channelsEdits?.[key]?.[field]) }
      }
    }));
  }

  async saveChannels() {
    const { channelsWebsiteId, channelsEdits } = this.state;
    if (!channelsWebsiteId) return;
    try {
      this.setState({ channelsLoading: true });
      await updateMyChannels(channelsWebsiteId, { channels: channelsEdits });
      alert('Canaux mis à jour');
      this.setState({ channelsLoading: false, channelsData: channelsEdits });
    } catch (e) {
      alert(`Erreur lors de la mise à jour: ${e?.message || e}`);
      this.setState({ channelsLoading: false });
    }
  }

  componentDidMount() {
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this._isMounted = true;
    this.fetchPage(1, parsed.user_id || '');
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1, this.state.q);
  }

  onPageChange(e, value) {
    this.fetchPage(value, this.state.q);
  }

  fetchPage(page, q) {
    const { website_id, age_min, age_max, profile_email, uid, sort_field, sort_type, page_size, sizeFlag, countFlag } = this.state;
    this.setState({ isLoading: true });

    const params = {
      website_id: website_id || undefined,
      query: (q || '').trim() || undefined,
      age_min: age_min !== '' ? parseInt(age_min, 10) : undefined,
      age_max: age_max !== '' ? parseInt(age_max, 10) : undefined,
      page_size: page_size || 10,
      page_nbr: page || 1,
      sort_field: sort_field || 'created_at',
      sort_type: sort_type || 'desc',
      profile_email: website_id && (profile_email || '').trim() ? (profile_email || '').trim() : undefined,
      uid: website_id && (uid || '').trim() ? (uid || '').trim() : undefined,
      size: !!sizeFlag || undefined,
      count: !!countFlag || undefined
    };

    getUsers(params)
      .then((result) => {
        if (!this._isMounted) return;
        // Handle size-only and count-only responses
        const sizeOnly = (result && typeof result.users === 'number') ? result.users : null;
        const countOnly = (result && typeof result.nbr === 'number') ? result.nbr : null;
        const listUsers = Array.isArray(result?.users) ? result.users : [];
        this.setState({
          hits: listUsers,
          page: parseFloat(result?.page_nbr) || page,
          total_elem: parseFloat(result?.total_elem) || 0,
          resultsSize: sizeOnly,
          resultsCount: countOnly,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  updateLimitCreateWebsite(user, newValue) {
    websiteLimit(user._id, newValue)
      .then(() => this.fetchPage(this.state.page, this.state.q));
  }

  toggleExpand(id) {
    this.setState((prev) => ({ expanded: { ...prev.expanded, [id]: !prev.expanded[id] } }));
  }

  openMenu(item, e) {
    this.setState({ menuAnchorEl: e.currentTarget, menuItem: item });
  }

  closeMenu() {
    this.setState({ menuAnchorEl: null, menuItem: null });
  }

  async handleDeleteUser(user) {
    if (!user) return;
    const ok = window.confirm(`Supprimer définitivement l'utilisateur ${user.username || user._id} ? Cette action est irréversible.`);
    if (!ok) {
      this.closeMenu();
      return;
    }
    try {
      this.setState({ isLoading: true });
      await deleteUser(user._id);
      // Rechargement des données
      await this.fetchPage(this.state.page, this.state.q);
    } catch (err) {
      alert(`Erreur lors de la suppression de l'utilisateur: ${err?.message || err}`);
      this.setState({ isLoading: false });
    } finally {
      this.closeMenu();
    }
  }

  async handleDeleteProfile(websiteId, userId) {
    if (!websiteId || !userId) return;
    const ok = window.confirm(`Supprimer le profil de l'utilisateur ${userId} pour le site ${websiteId} ?`);
    if (!ok) return;
    try {
      this.setState({ isLoading: true });
      await deleteUserProfile(websiteId, userId);
      await this.fetchPage(this.state.page, this.state.q);
    } catch (err) {
      alert(`Erreur lors de la suppression du profil: ${err?.message || err}`);
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { hits, page, total_elem, isLoading, q, expanded, menuAnchorEl, menuItem, website_id, age_min, age_max, profile_email, uid, sort_field, sort_type, page_size, sizeFlag, countFlag, resultsSize, resultsCount, showAdvanced } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / (page_size || 10)));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h6">Utilisateurs</Typography>
            <Chip size="small" label={`Résultats: ${total_elem || 0}`} />
          </Stack>
          <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, width: { xs: '100%', sm: 'auto' } }}>
            <TextField
              size="small"
              placeholder="Rechercher… (ex: jane, is:ban, facebook:123, website:ID, age:18-35, profile_email:jane@ex.com, uid:abc123, size, count)"
              value={q}
              onChange={(e) => this.setState({ q: e.target.value })}
              helperText="Astuce: facebook:ID, google:ID, twitter:ID, website:WEBSITE_ID, age:MIN-MAX, profile_email:EMAIL, uid:UID, is:ban/vip, size, count"
              sx={{ minWidth: { xs: '100%', sm: 420 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: q ? (
                  <InputAdornment position="end">
                    <IconButton size="small" aria-label="Effacer" onClick={() => this.setState({ q: '' }, () => this.fetchPage(1, ''))}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            />
            <Button variant="contained" type="submit" disabled={isLoading} startIcon={isLoading ? <CircularProgress size={18} /> : null}>Rechercher</Button>
            <Button variant="text" onClick={() => this.setState({ showAdvanced: !showAdvanced })}>
              {showAdvanced ? 'Masquer les filtres' : 'Filtres avancés'}
            </Button>
          </Box>
        </Stack>

        {isLoading && <LinearProgress sx={{ mb: 1 }} />}

        {/* Quick filters */}
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
          <FilterListIcon fontSize="small" />
          <Typography variant="subtitle2">Filtres rapides</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: 'wrap' }}>
          {['is:ban','is:vip','is:troll'].map((flag) => (
            <Chip
              key={flag}
              size="small"
              label={flag}
              onClick={() => this.setState({ q: flag }, () => this.fetchPage(1, flag))}
              variant="outlined"
            />
          ))}
          <Chip size="small" label="size" onClick={() => this.setState({ q: 'size' }, () => this.fetchPage(1, 'size'))} />
          <Chip size="small" label="count" onClick={() => this.setState({ q: 'count' }, () => this.fetchPage(1, 'count'))} />
        </Stack>

        {showAdvanced && (
          <Paper variant="outlined" sx={{ mb: 2, p: 2 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
              <TextField
                label="Website ID"
                size="small"
                value={website_id}
                onChange={(e) => this.setState({ website_id: e.target.value })}
              />
              <TextField
                label="Profile Email (website)"
                size="small"
                value={profile_email}
                onChange={(e) => this.setState({ profile_email: e.target.value })}
                helperText="Nécessite un Website ID"
              />
              <TextField
                label="Profile UID (website)"
                size="small"
                value={uid}
                onChange={(e) => this.setState({ uid: e.target.value })}
                helperText="Nécessite un Website ID"
              />
              <TextField
                label="Age min"
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                value={age_min}
                onChange={(e) => this.setState({ age_min: e.target.value })}
              />
              <TextField
                label="Age max"
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                value={age_max}
                onChange={(e) => this.setState({ age_max: e.target.value })}
              />
              <Select size="small" value={sort_field} onChange={(e) => this.setState({ sort_field: e.target.value })}>
                <MenuItem value="username">username</MenuItem>
                <MenuItem value="created_at">created_at</MenuItem>
              </Select>
              <Select size="small" value={sort_type} onChange={(e) => this.setState({ sort_type: e.target.value })}>
                <MenuItem value="asc">asc</MenuItem>
                <MenuItem value="desc">desc</MenuItem>
              </Select>
              <TextField
                label="Page size"
                size="small"
                type="number"
                inputProps={{ min: 1 }}
                value={page_size}
                onChange={(e) => this.setState({ page_size: parseInt(e.target.value || '10', 10) || 10 })}
                sx={{ width: 120 }}
              />
            </Stack>
            <Divider sx={{ my: 1 }} />
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
              <FormControlLabel
                control={<Checkbox checked={sizeFlag} onChange={(e) => this.setState({ sizeFlag: e.target.checked, countFlag: e.target.checked ? false : this.state.countFlag })} />}
                label="Retourner uniquement la taille (size=true)"
              />
              <FormControlLabel
                control={<Checkbox checked={countFlag} onChange={(e) => this.setState({ countFlag: e.target.checked, sizeFlag: e.target.checked ? false : this.state.sizeFlag })} />}
                label="Compter tous les utilisateurs (admin)"
              />
              <Button variant="outlined" onClick={(e) => { e.preventDefault(); this.fetchPage(1, this.state.q); }}>Appliquer</Button>
            </Stack>
          </Paper>
        )}

        {resultsCount !== null && (
          <Paper variant="outlined" sx={{ mb: 2, p: 2 }}>
            <Typography>Nombre total d'utilisateurs en base: <b>{resultsCount}</b></Typography>
          </Paper>
        )}
        {resultsSize !== null && (
          <Paper variant="outlined" sx={{ mb: 2, p: 2 }}>
            <Typography>Taille de la communauté (avec filtres): <b>{resultsSize}</b></Typography>
          </Paper>
        )}

        {(resultsSize === null && resultsCount === null) && (
        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>Login</TableCell>
                  <TableCell>Picture</TableCell>
                  <TableCell>Created</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Site Limite</TableCell>
                  <TableCell>Id</TableCell>
                  <TableCell>Token</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && hits.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center">Chargement…</TableCell>
                  </TableRow>
                ) : (
                  hits.map((item) => {
                    const open = !!expanded[item._id];
                    const token = item.validation ? (item.validation.v_token || '') : '';
                    return (
                      <React.Fragment key={item._id}>
                        <TableRow hover>
                          <TableCell width={48} sx={{ py: 0 }}>
                            <IconButton size="small" onClick={() => this.toggleExpand(item._id)} aria-label={open ? 'Réduire' : 'Développer'}>
                              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                          </TableCell>
                          <TableCell>{item.username}</TableCell>
                          <TableCell align="center" sx={{ width: 44 }}>
                            <Avatar src={item.picture} alt={item.username} sx={{ width: 20, height: 20, mx: 'auto' }} />
                          </TableCell>
                          <TableCell sx={{ maxWidth: 140 }}>
                            <Tooltip title={item.created_at || ''}>
                              <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                {item.created_at}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell sx={{ maxWidth: { xs: 200, md: 420 } }}>
                            <Tooltip title={item.email || (item.validation ? (item.validation.v_email || '') : '')}>
                              <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                {item.email || (item.validation ? (item.validation.v_email || '') : '') || '—'}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Select
                              size="small"
                              value={String(item.create_website_limit || 20)}
                              onChange={(e) => this.updateLimitCreateWebsite(item, e.target.value)}
                            >
                              <MenuItem value="20">20</MenuItem>
                              <MenuItem value="30">30</MenuItem>
                              <MenuItem value="50">50</MenuItem>
                              <MenuItem value="0">no-limit(0)</MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell sx={{ width: { xs: 200, md: 320 } }}>
                            <Tooltip title={item._id}>
                              <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                {item._id}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell sx={{ width: { xs: 160, md: 320 } }}>
                            <Tooltip title={token}>
                              <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                {token}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="right" sx={{ py: 0 }}>
                            <IconButton size="small" onClick={(e) => this.openMenu(item, e)} aria-label="Plus d'actions">
                              <MoreVertIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                              <Box sx={{ p: 2 }}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                  <PersonOutlineIcon fontSize="small" />
                                  <Typography variant="subtitle2">Identité</Typography>
                                </Stack>
                                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 2 }}>
                                  <Stack direction="row" spacing={1} alignItems="center">
                                    <CalendarTodayIcon fontSize="small" />
                                    <Tooltip title={`Créé le: ${item.created_at || ''} | Mis à jour: ${item.updated_at || ''}`}>
                                      <Typography variant="body2">{item.created_at}</Typography>
                                    </Tooltip>
                                  </Stack>
                                  {item.email && (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                      <EmailOutlinedIcon fontSize="small" />
                                      <Typography variant="body2" sx={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.email}</Typography>
                                    </Stack>
                                  )}
                                  {item.from_website && (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                      <LinkIcon fontSize="small" />
                                      <MuiLink component={RouterLink} to={`/super-admin/website/?website_id=${item.from_website}`} underline="hover">
                                        {item.from_website}
                                      </MuiLink>
                                    </Stack>
                                  )}
                                  <Chip size="small" label={`role: ${item.role}`} />
                                  <Chip size="small" label={`lang: ${item.language || '—'}`} variant="outlined" />
                                  {typeof item.security_google_only === 'boolean' && (
                                    <Tooltip title={item.security_google_only ? 'Connexion uniquement via Google' : 'Connexion libre'}>
                                      <Chip size="small" icon={<SecurityIcon fontSize="small" />} label={item.security_google_only ? 'google only' : 'auth mixed'} variant={item.security_google_only ? 'filled' : 'outlined'} />
                                    </Tooltip>
                                  )}
                                  {typeof item.disable_mail_notif === 'boolean' && (
                                    <Tooltip title={item.disable_mail_notif ? 'Notifications email désactivées' : 'Notifications email actives'}>
                                      <Chip size="small" icon={item.disable_mail_notif ? <NotificationsOffOutlinedIcon fontSize="small" /> : <NotificationsActiveOutlinedIcon fontSize="small" />} label={item.disable_mail_notif ? 'mail off' : 'mail on'} variant={item.disable_mail_notif ? 'filled' : 'outlined'} />
                                    </Tooltip>
                                  )}
                                </Stack>

                                {/* Section Accès Websites (déplacée du tableau principal) */}
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1, mb: 1 }}>
                                  <LanguageIcon fontSize="small" />
                                  <Typography variant="subtitle2">Websites</Typography>
                                  <Tooltip title="Voir les websites de l'utilisateur">
                                    <IconButton
                                      size="small"
                                      component={RouterLink}
                                      to={`/super-admin/website?owner=${item._id}`}
                                      aria-label="Voir les websites de l'utilisateur"
                                    >
                                      <LanguageIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Stack>

                                {/* Section Réseaux sociaux (déplacée du tableau principal) */}
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                  <Typography variant="subtitle2">Réseaux</Typography>
                                  <Stack direction="row" spacing={0.5} alignItems="center">
                                    {item.facebook_id && (
                                      <Tooltip title={`Facebook: ${item.facebook_id}`}>
                                        <FacebookIcon fontSize="small" color="primary" />
                                      </Tooltip>
                                    )}
                                    {item.google_id && (
                                      <Tooltip title={`Google: ${item.google_id}`}>
                                        <GoogleIcon fontSize="small" color="action" />
                                      </Tooltip>
                                    )}
                                    {item.twitter_id && (
                                      <Tooltip title={`Twitter: ${item.twitter_id}`}>
                                        <TwitterIcon fontSize="small" color="primary" />
                                      </Tooltip>
                                    )}
                                  </Stack>
                                </Stack>

                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2, mb: 1 }}>
                                  <AccountTreeIcon fontSize="small" />
                                  <Typography variant="subtitle2">Profils</Typography>
                                </Stack>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>profile id</TableCell>
                                      <TableCell>Username</TableCell>
                                      <TableCell>Picture</TableCell>
                                      <TableCell>Email</TableCell>
                                      <TableCell>Status</TableCell>
                                      <TableCell>Uid</TableCell>
                                      <TableCell>Score received</TableCell>
                                      <TableCell>Moderation % neg.</TableCell>
                                      <TableCell>Communauté</TableCell>
                                      <TableCell>Website id</TableCell>
                                      <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {(item.profiles && item.profiles.length > 0) ? item.profiles.map(profile => (
                                      <TableRow key={profile._id}>
                                        <TableCell sx={{ fontFamily: 'monospace' }}>{profile._id}</TableCell>
                                        <TableCell>{profile.username}</TableCell>
                                        <TableCell><Avatar src={profile.picture} alt={profile.username} sx={{ width: 20, height: 20 }} /></TableCell>
                                        <TableCell sx={{ maxWidth: { xs: 140, md: 220 } }}>
                                          <Tooltip title={profile.email || ''}>
                                            <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                              {profile.email || '—'}
                                            </Typography>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                          <Chip size="small" label={profile.status} color={profile.status === 'validated' ? 'success' : profile.status === 'pending' ? 'warning' : 'default'} />
                                        </TableCell>
                                        <TableCell>{profile.uid}</TableCell>
                                        <TableCell>{profile.score_received}</TableCell>
                                        <TableCell>{profile.moderation_percentage_negative}</TableCell>
                                        <TableCell>{profile.website?.name}</TableCell>
                                        <TableCell>
                                          <MuiLink component={RouterLink} to={`/super-admin/website/?website_id=${profile.website?._id}`} underline="hover">
                                            {profile.website?._id}
                                          </MuiLink>
                                        </TableCell>
                                        <TableCell align="right">
                                          <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                                            <Tooltip title="Canaux de notification (moi)">
                                              <span>
                                                <IconButton
                                                  size="small"
                                                  color="primary"
                                                  disabled={!profile.website?._id}
                                                  onClick={() => this.openChannelsDialog(profile.website?._id)}
                                                  aria-label="Voir/éditer mes canaux"
                                                >
                                                  <NotificationsActiveOutlinedIcon fontSize="small" />
                                                </IconButton>
                                              </span>
                                            </Tooltip>
                                            <Tooltip title="Supprimer ce profil">
                                              <span>
                                                <IconButton
                                                  size="small"
                                                  color="error"
                                                  disabled={!profile.website?._id}
                                                  onClick={() => this.handleDeleteProfile(profile.website?._id, item._id)}
                                                  aria-label="Supprimer le profil"
                                                >
                                                  <DeleteOutlineIcon fontSize="small" />
                                                </IconButton>
                                              </span>
                                            </Tooltip>
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    )) : (
                                      <TableRow>
                                        <TableCell colSpan={11} align="center">
                                          <Typography variant="body2" color="text.secondary">Aucun profil</Typography>
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })
                )}
                {!isLoading && hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
              siblingCount={0}
              boundaryCount={1}
            />
          </Box>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={this.closeMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            keepMounted
          >
            <MenuItem component={RouterLink} to={menuItem ? `/super-admin/website?owner=${menuItem._id}` : '#'} onClick={this.closeMenu}>
              Voir Websites
            </MenuItem>
            <MenuItem component={RouterLink} to={menuItem ? `/super-admin/Commentaires?author=${menuItem._id}` : '#'} onClick={this.closeMenu}>
              Voir Commentaires
            </MenuItem>
            {menuItem && (
              <MenuItem onClick={() => { navigator.clipboard?.writeText(menuItem._id); this.closeMenu(); }}>
                Copier l’ID
              </MenuItem>
            )}
            {menuItem && (
              <MenuItem onClick={() => this.handleDeleteUser(menuItem)}>
                Supprimer l'utilisateur
              </MenuItem>
            )}
          </Menu>

          {/* Channels dialog */}
          <Dialog open={this.state.channelsDialogOpen} onClose={this.closeChannelsDialog} maxWidth="sm" fullWidth>
            <DialogTitle>Canaux de notifications — website {this.state.channelsWebsiteId || ''}</DialogTitle>
            <DialogContent dividers>
              {this.state.channelsLoading && (
                <Stack alignItems="center" sx={{ py: 4 }}>
                  <CircularProgress size={24} />
                </Stack>
              )}
              {!this.state.channelsLoading && this.state.channelsEdits && (
                <Stack spacing={1}>
                  {(
                    [
                      'response_to_inbox',
                      'response_to_comment',
                      'response_to_page',
                      'new_subject_on_group',
                      'new_relation_to_accept',
                      'relation_accepted',
                      'new_group_to_accept',
                      'group_accepted'
                    ]
                  ).map((key) => (
                    <Stack key={key} direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }} justifyContent="space-between" spacing={1}>
                      <Typography variant="body2" sx={{ textTransform: 'none' }}>{key}</Typography>
                      <Stack direction="row" spacing={2}>
                        <FormControlLabel
                          control={<Checkbox checked={Boolean(this.state.channelsEdits?.[key]?.email)} onChange={() => this.toggleChannel(key, 'email')} />}
                          label="Email"
                        />
                        <FormControlLabel
                          control={<Checkbox checked={Boolean(this.state.channelsEdits?.[key]?.push)} onChange={() => this.toggleChannel(key, 'push')} />}
                          label="Push"
                        />
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeChannelsDialog}>Fermer</Button>
              <Button onClick={this.saveChannels} variant="contained" disabled={this.state.channelsLoading}>Enregistrer</Button>
            </DialogActions>
          </Dialog>
        </Paper>
        )}
      </Box>
    );
  }
}

export default User;